<script>
    import { createEventDispatcher } from 'svelte';

    import InstalledStatusSelect from './InstalledStatusSelect.svelte';
    import RemovalReasonSelect from './RemovalReasonSelect.svelte';
    import Text from '../Text.svelte';

    export let partRemoved;
    export let serialRemoved;
    export let removalReason;

    export let partInstalled;
    export let serialInstalled;
    export let installStatus;

    const dispatch = createEventDispatcher();

    const createChangeHandler = fieldName => ({ detail: value }) => dispatch('change', {
        fieldName,
        value,
    });
</script>

<div class="part-information">
    <div></div>
    <div>Removed</div>
    <div>Installed</div>

    <div>Part Installed</div>
    <div>
        <Text
            bind:value={partRemoved}
            on:change={createChangeHandler('part_number_removed')}
        />
    </div>
    <div>
        <Text
            bind:value={partInstalled}
            on:change={createChangeHandler('part_number_installed')}
        />
    </div>

    <div>Serial Number</div>
    <div>
        <Text
            bind:value={serialRemoved}
            on:change={createChangeHandler('serial_number_removed')}
        />
    </div>
    <div>
        <Text
            bind:value={serialInstalled}
            on:change={createChangeHandler('serial_number_installed')}
        />
    </div>

    <div></div>
    <div>Removal Reason</div>
    <div>Installed Status</div>

    <div></div>
    <div>
        <RemovalReasonSelect
            bind:value={removalReason}
            on:change={createChangeHandler('removal_reason')}
        />
    </div>
    <div>
        <InstalledStatusSelect
            bind:value={installStatus}
            on:change={createChangeHandler('installed_status')}
        />
    </div>
</div>

<style>
    .part-information {
        display: grid;
        grid-template-columns: auto repeat(2, 1fr);
        grid-template-rows: repeat(5, auto);
        gap: 5px 10px;
    }

    .part-information :global(.text) {
        margin: 0;
    }
</style>
